<template>
    <div class="info-modal">
        <div @click="show" class="cursor-pointer">
            <IconInformation  fill="var(--primary-contrast-color)" classes="w-6 mr-2" />
        </div>
    <transition name="slide-fade-reverse">
        <modal
        name="info"
        width="90%"
        transition="slide-fade-reverse"
        :maxWidth="480"
        height="auto"
        :adaptive="true"
        scrollable
        class="roundedmodal info-modal"
        @closed="hide"
        @before-close="closingModal"
        @before-open="openingModal"
        > 
        <div class="p-8">
            <div class="flex justify-between">
                <h2 class="mb-4 text-product-gray font-bold text-2xl justify-center">
                    {{menu.info_modal_properties[`title_${language}`]}}
                </h2>
                <button class="inline-flex" @click="hide">
                    <IconCancel
                    fill="none"
                    :stroke="languageModalDestructiveIconColor"
                    :backgroundColor="languageModalDestructiveBackgroundColor"
                    />
                </button>
            </div>
            <div class="content">
                {{menu.info_modal_properties[`description_${language}`]}}
            </div>
        </div>
        </modal>
    </transition>
    </div>
</template>

<script>
import IconInformation from './icons/iconInformation.vue';
import IconCancel from './icons/iconCancel.vue';
import {mapGetters} from 'vuex';

export default {
    name: "InfoModal",
    components: {
        IconInformation,
        IconCancel
    },
    props: {
        title: {
            type: String,
            default: () => "Info",
        },
        content: {
            type: String,
            default: () => "Info",
        },
    },
    mounted() {
        const showInfoModalArray = JSON.parse(localStorage.getItem("showInfoModal") || "[]");
        if (showInfoModalArray.includes(this.menu.menu_hash)) return;
        showInfoModalArray.push(this.menu.menu_hash);
        localStorage.setItem("showInfoModal", JSON.stringify(showInfoModalArray));
        this.$modal.show("info");
    },
    computed: {
        ...mapGetters(["language", "menu", "languagesCount"]),
        ...mapGetters("Theme",
            [
                "languageModalDestructiveBackgroundColor",
                "languageModalDestructiveIconColor"
            ]
        ),
    },
    methods: {
        hide() {
            this.$modal.hide("info");
        },
        show() {
            this.$modal.show("info");
        },
        showInfoModalFirstTime() {
            const showInfoModal = localStorage.getItem("showInfoModal");
            if (showInfoModal) return;

            this.$modal.show("info");
            localStorage.setItem("showInfoModal", true);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>